"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const store_1 = require("src/store/store");
const Api_1 = __importDefault(require("./Api"));
const API_BASE_URL = process.env.GATSBY_API_BASE_URL;
let httpClient;
if (process.env.NODE_ENV === "development") {
    httpClient = axios_1.default.create({
        // baseURL: API_BASE_URL,
        withCredentials: true,
    });
}
else {
    if (!API_BASE_URL) {
        process.exit(0);
    }
    httpClient = axios_1.default.create({
        baseURL: API_BASE_URL,
        withCredentials: true,
    });
}
httpClient.interceptors.response.use((response) => {
    // tslint:disable-next-line: no-unsafe-any
    return response.data;
}, (error) => {
    console.error("request error", error.message);
    if (error.response?.status === 401) {
        store_1.store.dispatch({ type: "LOGOUT" });
    }
    return Promise.reject(error);
});
const Service = new Api_1.default(httpClient);
exports.default = Service;
